import PropTypes from 'prop-types';
import React from 'react';

import { createBEMv2 } from '../../lib/utils/css';

import './Button.scss';

class Button extends React.Component {
  /**
   * @property {node} children - the content of the button
   * @property {Function} onClick - the function that fires when the button is clicked
   * @property {Array} classes - optional class(es) to be appended to button element to modify style
   * @property {boolean} isDisabled - if true, disables onClick and adds disabled styling
   */
  static propTypes = {
    children: PropTypes.node.isRequired,
    qaTag: PropTypes.string,
    onClick: PropTypes.func,
    classes: PropTypes.array,
    isDisabled: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
  };

  static defaultProps = {
    type: 'button',
  };

  render() {
    const { classes, type, onClick, isDisabled, qaTag } = this.props;

    const classNames = createBEMv2(
      'button',
      {
        disabled: isDisabled,
      },
      classes,
    );

    return (
      <button
        className={classNames}
        type={type}
        onClick={onClick}
        disabled={isDisabled}
        data-qa={qaTag}
      >
        {this.props.children}
      </button>
    );
  }
}

export default Button;
